const randomInteger = (min, max) => {
	const rand = Math.floor(min + Math.random() * (max + 1 - min));
	return rand;
};

export default randomInteger;



// WEBPACK FOOTER //
// ./app/scripts/util/generate/randomInteger.js